import React from 'react';
import NavigationItem from '../NavigationItems/NavigationItem/NavigationItem';

const Sidebar = (props) => {
    let classes = ["sidebar", "sidebar--closed"];

    if(props.sidebarShown){
        classes = ["sidebar", "sidebar--opened"]
    }

    return (
        <div className = {classes.join(' ')}>
            <div className="sidebar__container">
                <NavigationItem className = "sidebar__link" exact = {true} link = "/" delay = "300" clicked = {props.linkClicked}>Home</NavigationItem>
                <NavigationItem className = "sidebar__link" link = "/projects" delay = "200" clicked = {props.linkClicked}>Projects</NavigationItem>
                <NavigationItem className = "sidebar__link" link = "/contact" delay = "100" clicked = {props.linkClicked}>Contact</NavigationItem>  
                <NavigationItem className = "sidebar__link" link = "/about" clicked = {props.linkClicked}>About</NavigationItem>  
            </div>
        </div>
    );
};

export default Sidebar;